import { useContext } from "react";

import { classNames } from "@helpers/css";

import { OverallCoreValuesAssessmentQuestionDescriptionContext } from "./overall-core-values-question-context";

const OverallCoreValuesAssessmentQuestionDescription = ({
  className,
}: {
  className?: string;
}) => {
  const context = useContext(
    OverallCoreValuesAssessmentQuestionDescriptionContext,
  );

  return context.averageScoreOfIndividualCoreValuesBasedQuestions ? (
    <div className={classNames("mt-1 text-sm text-gray-400", className)}>
      Average score based on above Core Values assessments:{" "}
      {context.averageScoreOfIndividualCoreValuesBasedQuestions}/
      {context.scale ?? "3"}
    </div>
  ) : null;
};

export default OverallCoreValuesAssessmentQuestionDescription;
